/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FeedbackTypeV2FilterConfigColumn =
  (typeof FeedbackTypeV2FilterConfigColumn)[keyof typeof FeedbackTypeV2FilterConfigColumn];

export const FeedbackTypeV2FilterConfigColumn = {
  user_feedback_v2: 'user_feedback_v2',
} as const;
